export default __webpack_public_path__ + "static/media/cert-it-cpttm.33e8fc81.jpg";